import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../firebase'

const BUSINESS_PROFILE_DOC = doc(db, 'settings', 'businessProfile')

export const businessProfileService = {
  async get() {
    const snap = await getDoc(BUSINESS_PROFILE_DOC)
    if (snap.exists()) {
      return { id: snap.id, ...snap.data() }
    }

    const initial = {
      tradingName: '',
      legalName: '',
      registrationNumber: '',
      vatNumber: '',
      address: '',
      phone: '',
      email: '',
      receiptFooter: '',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }

    await setDoc(BUSINESS_PROFILE_DOC, initial)
    return { id: 'businessProfile', ...initial }
  },

  async update(patch) {
    await updateDoc(BUSINESS_PROFILE_DOC, {
      ...patch,
      updatedAt: serverTimestamp(),
    })
  },
}

